import React, { useEffect, useRef, useState } from 'react';
import { useCartState } from '../../../../contexts/cart';
import { useUserContext } from '../../../../aem-core-components/context/UserContext';
import { useFilterState } from '../../../cap';
import { useAnalyticsContext } from '../../../../config/GoogleTagManagerEvents';
import useAnalytics from '../../../../hooks/analytics/useAnalytics';
import { usePricing } from '../../../../hooks/usePricing';
import useCartAnalytics from '../../../../hooks/analytics/useCartAnalytics';
import useCheckLocationEmpty from '../../../../hooks/useCheckLocationEmpty';
import Carousel from '../../modules/alternateInventory/carousel/Carousel';
import AddToCartProductTileReact from '../../modules/productTile/addToCartProductTileReact/AddToCartProductTileReact';
import { setAccessTokenSession } from '../../modules/dataBricks/api/getDataBricks';
import { recommendationMobileResponsive, showGreenLeafTag } from '../../utils/commonUtils';
import { logError } from '../../utils/logger';
import { getDynamicProducts } from './api/getDynamicProducts';
import { ENV_CONFIG } from '../../../../constants/envConfig';
import { VARIABLE_CONFIG } from '../../../../constants/analyticsConstants/Variables';
import { dynamicSeasonalProductsConstant } from './dynamicSeasonalProductsConstant';
import isObjectWithKeys from '../../../../aem-core-components/utils/isObjectWithKeys';
import { STORAGE_CONFIG } from '../../../../constants/storageConfig';
import { SET_STATIC_SEASONAL_POPULAR_FLAGS } from '../../../cap/constants';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../constants/analyticsConstants/Ecommerce';


const DynamicSeasonalProducts = () => {
    const [{ cidPcList, isRatesLoading }] = useCartState();
    const [{}, filterDispatch] = useFilterState();
    const { getProductPrices } = usePricing();
    const [{ isProfileLoaded }] = useUserContext();
    const { sendEventsForViewItemList } = useAnalyticsContext();
    const [{ payloadEcommerceViewItemList }] = useAnalytics();
    const [{ sendAddToCartAnalytics }] = useCartAnalytics();
    const { isRentalDetailsAvailable } = useCheckLocationEmpty();
    const [dynamicProductsData, setDynamicProductsData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [isEmpty, setIsEmpty] = useState(false);
    const [triggerDynamicEvent, setTriggerDynamicEvent] = useState(false);
    const productRecommmendationsRef = useRef('null');
    const itemLength = dynamicProductsData?.length || dynamicSeasonalProductsConstant?.defaultItemLength;
    const productLength = dynamicProductsData?.length || 0;
    const minProducts = dynamicSeasonalProductsConstant?.minproductLength;
    const { fetchLocationCoordinates } = useCheckLocationEmpty();
    const { localLat, localLong } = fetchLocationCoordinates();
    const localCompanyId  = parseInt(localStorage?.getItem(STORAGE_CONFIG.LOCAL_STORAGE.COMPANYID)) || 1;


    // Fetch data from API
    const fetchDynamicSesonalOffering = async (month, maxdistance, maxresults, utlscore, latitute, longitude,setCountryCode) => {
        try {
            setIsLoading(true);
            await setAccessTokenSession();
            const { data } = await getDynamicProducts(month, maxdistance, maxresults, utlscore, latitute, longitude,setCountryCode);

            const seasonalOfferings = data?.data?.SeasonalOfferings || [];

            if (!seasonalOfferings || seasonalOfferings.length === 0) {
                setIsEmpty(true);
                setDynamicProductsData([]);
            } else {
                setDynamicProductsData(seasonalOfferings);
                setIsEmpty(false);
            }
            setIsLoading(false);
        } catch (error) {
            logError(error, false, 'fetchDynamicSesonalOffering');
            setIsLoading(false);
            setHasError(true);
            setDynamicProductsData([]);
        }
    };

    const getCountryCode = (CountryName) =>{
        switch(CountryName) {
            case 'canada':
            return 2
            default:
                return  1
          }
    }


  // Fetch  lat long from Adobe Target
  const getTargetLocationDetails = async () => {
    const { disablegeo } = ENV_CONFIG?.DYNAMIC_SEASONAL_PRODUCTS_DATASET;
    
    try {
        
        if (disablegeo) {
            return { longitude:localLong, latitude:localLat, companyId:localCompanyId };
        }

        if (!localLat || !localLong ) {
            const geoLocationDetails = await new Promise((resolve, reject) => {
                adobe?.target?.getOffer({
                    mbox: 'mbox-geo-rental-page',
                    success: function (offer) {
                        if (offer && offer?.length > 0) {
                            const geoLocationOffer = offer[0];
                            let geoLocationDetails = geoLocationOffer?.content[0];
                            geoLocationDetails.companyId = getCountryCode(geoLocationDetails?.country)
                            resolve(geoLocationDetails); // Resolve with the details
                        } else {
                            resolve(null); // Resolve with null if no offer
                        }
                    },
                    error: function (status, error) {
                        reject(error); // Reject in case of an error
                    }
                });
            });
            return geoLocationDetails; // Return the resolved details
        } else {
            return { longitude:localLong, latitude:localLat, companyId:localCompanyId };
        }
    } catch (error) {
        logError(error, false, 'getTargetLocationDetails');
        return {};
    }
};



    // Get all the data and  pass params to API Fetch call
    const getCarousalData = async () => {
        try {
            if (isProfileLoaded) {
                //test for location adobe target
                const targetLocatons = await getTargetLocationDetails();
                const setLocationLat = targetLocatons?.latitude;
                const setLocatonLong = targetLocatons?.longitude;
                const setCountryCode = targetLocatons?.companyId;
                const currentMonth = new Date().getMonth() + 1;
                const { maxdistance, maxresults, utlscore } = ENV_CONFIG?.DYNAMIC_SEASONAL_PRODUCTS_DATASET;
                const {
                    maxdistance: maxDistanceConst,
                    maxresults: maxResultsConst,
                    utlscore: utlsCoreConst
                } = dynamicSeasonalProductsConstant;
                const maxDistance = maxdistance || maxDistanceConst;
                const maxResults = maxresults || maxResultsConst;
                const utlScore = utlscore || utlsCoreConst;

                if (!setLocationLat || !setLocatonLong) {
                    setHasError(true);
                    setIsLoading(false);
                    return;
                }
                await fetchDynamicSesonalOffering(
                    currentMonth,
                    maxDistance,
                    maxResults,
                    utlScore,
                    setLocationLat,
                    setLocatonLong,
                    setCountryCode
                );
                setHasError(false);   
            }
        } catch (error) {
            logError(error, false, 'getCarousalData');
        }
    };

    // function for checking style
    const setDisplay = (element, displayValue) => {
        if (element?.style) {
            element.style.display = displayValue;
        }
    };

    useEffect(() => {
        getCarousalData();
    }, [isProfileLoaded, localLong, localLat]);

    useEffect(() => {
        try {
            const fetchRates = async () => {
                await getProductPrices(dynamicProductsData, VARIABLE_CONFIG?.PAGE_TYPE?.EQUIPMENT_AND_TOOLS_PAGE);
            };
            if (isProfileLoaded) {
                if (isRentalDetailsAvailable() && cidPcList?.length > 0 && dynamicProductsData?.length > 0) {
                    fetchRates();
                }
            }
        } catch (error) {
            logError(error, false, 'fetchProductRecommendations');
        }
    }, [cidPcList, isProfileLoaded, dynamicProductsData]);

    useEffect(() => {
        const popularShimmer = document?.querySelector('.parent_div_dynamic_seasonal_products .row--popular-shimer');
        const popularCarousalReact = document?.querySelector(
            '.parent_div_dynamic_seasonal_products .dynamic-seasonal-products'
        );
        const staticProductRecommendations = document?.querySelector(
            '.parent_div_dynamic_seasonal_products .aemproduct__carousel-wrap'
        );
        if (isLoading) {
            setDisplay(popularShimmer, 'flex');
            setDisplay(popularCarousalReact, 'none');
            setDisplay(staticProductRecommendations, 'none');
            filterDispatch({ type: SET_STATIC_SEASONAL_POPULAR_FLAGS });
            setTriggerDynamicEvent(false);
        } else if (hasError || isEmpty || dynamicProductsData?.length < minProducts) {
            setDisplay(popularShimmer, 'none');
            setDisplay(popularCarousalReact, 'none');
            setDisplay(staticProductRecommendations, 'block');
            filterDispatch({
                type: SET_STATIC_SEASONAL_POPULAR_FLAGS,
                staticSeasonalPopularFlags: {
                    showSeasonal: true,
                    showPopular: true
                }
            });
            setTriggerDynamicEvent(false);
            window.slickCarousalRefresh(
                '.parent_div_dynamic_seasonal_products .aemproduct__carousel-wrap .aemproduct__carousel'
            );
        } else {
            setDisplay(popularShimmer, 'none');
            setDisplay(popularCarousalReact, 'block');
            setDisplay(staticProductRecommendations, 'none');
            filterDispatch({
                type: SET_STATIC_SEASONAL_POPULAR_FLAGS,
                staticSeasonalPopularFlags: {
                    showPopular: true
                }
            });
            setTriggerDynamicEvent(true);
        }
    }, [cidPcList, productLength, isLoading, hasError, isEmpty]);

    useEffect(() => {
        if (!isRatesLoading && triggerDynamicEvent && dynamicProductsData?.length > 0) {
            try {
                sendEventsForViewItemList(
                    EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_VIEW_ITEM_LIST,
                    payloadEcommerceViewItemList(dynamicProductsData)
                );
                setTriggerDynamicEvent(false);
            } catch (error) {
                setTriggerDynamicEvent(false);
                logError(error, false, 'sendEventsForViewItemList-DynamicSeasonalProducts');
            }
        }
    }, [isRatesLoading, triggerDynamicEvent, dynamicProductsData]);

    const trackAddToCartAnalytics = (item = {}) => {
        try {
            if (isObjectWithKeys(item)) {
                sendAddToCartAnalytics(item, true);
            }
        } catch (error) {
            logError(error, false, 'trackAddToCartAnalytics');
        }
    };

    const renderCarouselItems = dynamicProductsData => {
        return dynamicProductsData?.map((singleDynamicProduct, index) => {
            const {
                catclass,
                productimageurl,
                producttitle,
                producturl,
                metadescription,
                metatitle,
                ec_pc_inventory,
                disableaddtocartoption,
                showonlinecatalog,
                categoryname,
                parentCategory,
                categories,
                isgreenleaf,
                greenleafdata,
                accessoriesAddons,
            } = singleDynamicProduct;

            const cardData = {
                catclass,
                productimageurl,
                producttitle,
                producturl,
                metadescription,
                metatitle,
                catsku: catclass,
                inventory: ec_pc_inventory || '{}',
                disableaddtocartoption,
                showonlinecatalog,
                listName: VARIABLE_CONFIG?.PRODUCT_CARD?.SEASONAL_LIST_NAME,
                categoryname,
                parentCategory,
                categoryname: categories?.[0]?.name || categoryname,
                parentCategory: categories?.[1]?.name || parentCategory,
                subcategoryname: categories?.[2]?.name,
                position: index + 1,
                index:index,
                isgreenleaf: showGreenLeafTag(isgreenleaf),
                greenleafdata: greenleafdata,
                accessoriesaddons: accessoriesAddons,
            };

            return <AddToCartProductTileReact key={catclass} cardData={cardData}  handleAddToCartClickAnalytics={trackAddToCartAnalytics} />;
        });
    };

    return (
        <div ref={productRecommmendationsRef}>
            <Carousel
                disableDotsControls={false}
                totalItem={itemLength}
                mobileResponsive={recommendationMobileResponsive()}
                carouselWrapClasses={'carousel--dynamic-seasonal-products'}>
                {renderCarouselItems(dynamicProductsData)}
            </Carousel>
        </div>
    );
};

export default DynamicSeasonalProducts;
